import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  PageHeader,
  PageTitle,
  useFormHandler,
  Avatar,
} from "../../../../../components";
import { useNavigate } from "react-router-dom";
import ReviseTimesheetsModal from "./Payconfigurations/ReviseTimesheetsModal";

const OffCyclePayment = () => {
  const navigate = useNavigate();

  const { formData, handleChange } = useFormHandler(
    {
      employeeName: "",
      paymentType: "",
      amount: "",
      referenceCycle: "",
      timesheetRequired: "No Timesheet",
      showInPreviousCycle: "No",
      paymentTyp: "",
      basePay: "",
      lcaWages: "1,00,000",
      lcaType: "",
      lcaTimePeriodFrom: "01/01/2024",
      lcaTimePeriodTo: "01/01/2029",
      reasonNotes: "",
      receivedPaymentCheckbox: [],
    },
    {}
  );

  const handleBack = () => {
    navigate(-1);
  };

  const isOffGridPay =
    [1, 3, 4].includes(
      formData.paymentType && typeof formData.paymentType === "object"
        ? formData.paymentType?.value
        : formData.paymentType
    );


  const [isReviseTimesheetsModal, setISReviseTimesheetsModal] = useState(false);

  // Dummy dynamic data for Received Payment card
  const receivedPaymentDetails = {
    name: "Abdul",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
    receivedFrom: "Vikranth",
    date: "10/10/2024",
    exchangeAmount: "$189.00",
    receivedAmount: "$678.00",
  };

  return (
    <div className="w-full px-4 py-6">
      <PageHeader
        Section={
          // <div className="flex items-center gap-2">     
            <PageTitle title="All Off-Cycle Payments" tag="h6" />  
        }
        RightSection={
          <Button
            title="Back"
            icon="arrow_back"
            color="primary"
            onClick={handleBack}
            size="sm"
            className="!bg-[#f97316] hover:!bg-[#ea580c]"
          />
        }
      />

      
      <div className="mt-6 flex flex-col xl:flex-row gap-4 xl:items-stretch">
        <div className="flex-1 min-w-0 w-full bg-white p-8 rounded-xl border border-gray-100 shadow-sm flex flex-col justify-between">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-8">

            {/* Employee Name */}
            <FormFieldSet
              type="select"
              title="Employee Name"
              placeholder="Select"
              options={[
                { label: "Vikrant", value: 1 },
                { label: "Ershad", value: 2 },
                { label: "Aastha", value: 3 },
                { label: "Vijaya", value: 4 },
              ]}
              value={formData.employeeName}
              onChange={(val) => handleChange("employeeName", val)}
  
            />

            {/* Payment Type */}
            <FormFieldSet
              type="select"
              title="Payment Type"
              placeholder="Select"
              options={[
                { label: "Bonus", value: 1 },
                { label: "Fixed Salary", value: 2 },
                { label: "Off-Grid pay", value: 3 },
                { label: "Other", value: 4 },
              ]}
              value={formData.paymentType}
              onChange={(val) => handleChange("paymentType", val)}
            />

            {/* Amount */}
            <FormFieldSet
              type="text"
              title="Amount (₹)"
              placeholder="85,659"
              value={formData.amount}
              onChange={(val) => handleChange("amount", val)}
            />

            {/* Reference Cycle */}
            <FormFieldSet
              type="select"
              title="Reference Cycle"
              placeholder="Select"
              value={formData.referenceCycle}
              onChange={(val) => handleChange("referenceCycle", val)}
            />

            <FormFieldSet
              type="radio"
              title="Timesheet Required ?"
              name="timesheetRequired"
              options={[
                { label: "Yes", value: 1 },
                { label: "No", value: 2 },
              ]}
              value={formData.timesheetRequired}
              onChange={(e) => handleChange("timesheetRequired", e.target.value)}
            />

            <FormFieldSet
              type="radio"
              name="showInpayCycle"
              title="Show in Pay Cycle?"
              options={[
                { label: "Yes", value:1 },
                { label: "No", value: 2 },
              ]}
              value={formData.showInpayCycle}
              onChange={(e) => handleChange("showInpayCycle", e.target.value)}
            
            />
            <>
              <FormFieldSet
                type="select"
                title="Payment Typ"
                placeholder="Select Payment Type"
                options={[
                  { label: "Salaried", value: 1 },
                  { label: "As Per Placements", value: 2 },
                  { label: "Salary as per Placements", value: 3 },
                ]}
                value={formData.paymentTyp}
                onChange={(val) => handleChange("paymentTyp", val)}
              
              />

              <div className="flex items-end gap-2">
                <div className="flex-1">
                  <FormFieldSet
                    type="text"
                    title="Base Pay"
                    placeholder="Enter Base Pay"
                    value={formData.basePay}
                    onChange={(val) => handleChange("basePay", val)}
                  
                  />
                </div>
                <span className="mb-[6px] text-gray-400 text-sm whitespace-nowrap">/ (Month)</span>
              </div>

              <div className="hidden lg:block" />

              <FormFieldSet
                type="text"
                title="LCA Wages"
                placeholder="1,00,000"
                value={formData.lcaWages}
                onChange={(val) => handleChange("lcaWages", val)}
            
              />

              <FormFieldSet
                type="select"
                title="LCA Type"
                placeholder="LCA Type"
                options={[
                  { label: "Monthly", value: 1 },
                  { label: "Weekly", value: 2 },
                ]}
                value={formData.lcaType}
                onChange={(val) => handleChange("lcaType", val)}
                
              />

              <div className="col-span-1 flex gap-1">
                <FormFieldSet
                  type="datepicker"
                  title="LCA Time Period"
                  placeholder="01/01/2025"
                  value={formData.lcaTimePeriodFrom}
                  onChange={(val) => handleChange("lcaTimePeriodFrom", val)}
                  showDropdown={false}
                />
                <div>
                  <FormFieldSet
                    type="datepicker"
                    title=" "
                    placeholder="01/01/2027"
                    value={formData.lcaTimePeriodTo}
                    onChange={(val) => handleChange("lcaTimePeriodTo", val)}
                    showDropdown={false}
                  />
                </div>
              </div>
            </>

            <div className="col-span-1 md:col-span-2 lg:col-span-3">
              <FormFieldSet
                type="textArea"
                title="Reason / Notes"
                placeholder="Type here..."
                value={formData.reasonNotes}
                onChange={(val) => handleChange("reasonNotes", val)}
               
                rows={4}
              />
            </div>
          </div>

          <div className="flex justify-end gap-4 mt-10">
            <Button
              variant="text"
              title={"Revise"}
              icon={"change_circle"}
              onClick={() => setISReviseTimesheetsModal(!isReviseTimesheetsModal)}
            />
            <Button
              title="Cancel"
              variant="outlined"
              onClick={handleBack}
              className="!border-orange-500 !text-orange-500 hover:!bg-orange-50"
            />
            <Button
              title="Save"
              onClick={() => {}}
              className="!bg-[#f97316] hover:!bg-[#ea580c] !text-white"
            />
          </div>


          {isReviseTimesheetsModal && (
            <ReviseTimesheetsModal
              open={isReviseTimesheetsModal}
              onClose={() => setISReviseTimesheetsModal(false)}
              tableData={[]}
              setTableData={() => {}}
              setPredictData={() => {}}
              predictData={[]}
              filteredPlacementsActive={[]}
              formattedPlacements={[]}
              LCStypes={[]}
              lcaList={[]}
              empPayConfigData={[]}
              handleCallApi={() => {}}
              employeeProfileUiid={""}
              loginUserUiid={""}
              dispatch={() => {}}
              formDataFromParent={{}}
              placementId={[]}
            />
          )}
        </div>

        {isOffGridPay && (
          <div className="w-full xl:w-[340px] shrink-0 bg-white rounded-xl border border-gray-200 shadow-sm p-4">
            <h3 className="text-lg font-normal text-gray-800 pb-3 mb-4 border-b border-gray-100">
              Received Payment
            </h3>

            {/* Card */}
            <div className="border border-gray-100 rounded-lg shadow-sm p-3">
              {/* Avatar + Name */}
              <div className="flex items-center gap-3 mb-3">
                <Avatar size="md" alt={receivedPaymentDetails.name} />
                <span className="text-md font-medium text-gray-700">{receivedPaymentDetails.name}</span>
              </div>

              {/* Description */}
              <p className="text-xs font-normal text-gray-700 mb-4">
                {receivedPaymentDetails.description}
              </p>

              {/* Received From / Date row */}
              <div className="grid grid-cols-2 gap-3 mb-4">
                <div>
                  <p className="text-sm font-semibold text-gray-700 whitespace-nowrap">Received From</p>
                  <p className="text-sm text-gray-500 mt-0.5">{receivedPaymentDetails.receivedFrom}</p>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-700">Date</p>
                  <p className="text-sm text-gray-500 mt-0.5">{receivedPaymentDetails.date}</p>
                </div>
              </div>

              {/* Exchange / Received amount row */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <p className="text-sm font-semibold text-gray-700 whitespace-nowrap">Exchange Amount</p>
                  <p className="text-sm text-gray-500 mt-0.5">{receivedPaymentDetails.exchangeAmount}</p>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-700 whitespace-nowrap">Received Amount</p>
                  <p className="text-sm text-gray-500 mt-0.5">{receivedPaymentDetails.receivedAmount}</p>
                </div>
              </div>

              {/* Checkbox*/}
              <div className="mt-4 pt-4 border-t border-gray-100 flex justify-start items-center">
                <div className="-mt-1"> 
                  <FormFieldSet
                    type="checkbox"
                    size="md"
                    noTitle
                    options={[
                      { label: "", value: true }
                    ]}
                    values={formData.receivedPaymentCheckbox}
                    onChange={(val) => handleChange("receivedPaymentCheckbox", val)}
                    multiple
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OffCyclePayment;
